// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"561":"2037f352","767":"e823892d","844":"98aaded4"}[chunkId] + ".chunk.css";
};